module.exports = __webpack_public_path__ + "static/media/logoorange.6f5d542e.png";